import React, { useState } from 'react';
// import PropTypes from 'prop-types';
import ReactTable from 'react-table';
import { Card, CardHeader, Collapse } from 'reactstrap';
import { UpOutlined, DownOutlined } from '@ant-design/icons';

const column1 = [
  {
    Header: 'Solicitation',
    accessor: 'solNum',
  },
  {
    Header: 'Status',
    accessor: 'solStatus',
  },
  {
    Header: 'Quanity',
    accessor: 'prQty',
  },

  {
    Header: 'UI',
    accessor: 'UI',
  },

  {
    Header: 'Closes',
    accessor: 'solCloseDate',
  },

  {
    Header: 'Small',
    accessor: 'small',
  },
];

const Header = data => {
  const [toggleQuestion, setToggequestion] = useState(1);
  return (
    <div className="nf-u-details__grid">
      <Card className="nf-solicitation-detail__card">
        <CardHeader
          className="nf-solicitation-detail__card-header"
          onClick={() => setToggequestion(!toggleQuestion)}
        >
          Recent Solicitations{' '}
          {toggleQuestion ? <UpOutlined /> : <DownOutlined />}
        </CardHeader>

        <Collapse isOpen={toggleQuestion}>
          <ReactTable
            data={data.block}
            columns={column1}
            defaultPageSize={data.block.length > 0 ? data.block.length : 3}
            style={{ textAlign: 'left' }}
            showPagination={false}
          />
        </Collapse>
      </Card>

      {/* <Table dataSource={drawings} columns={columns} /> */}
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/pages/universalDetails/niinDetailTables/RecentSolicitations.jsx